//#region import
import React, { useCallback, useContext, useEffect, useMemo, useState } from 'react';
import { Divider, Grid, Tooltip, Typography } from '@mui/material';
import { ProjectContext } from '../ProjectRequestFrom';
import { Convert, FnAxios, FnDialog, I18n, ParseHtml, RouterDOM, formatNumber } from 'utilities/utilities';
import { APIStatusCode, EnumProjectPresentStatusID, EnumProjectStatusFinalScore, EnumProjectStatusID, EnumSaveModeProject, I18NextNs } from 'enum/enum';
import { Router, useLocation, useNavigate } from 'react-router';
import { ApiProject } from 'enum/api';
import AccordionPanel from '../components/AccordionPanel';
import { FormProvider, useForm } from 'react-hook-form';
import PresentFrom from './PresentFrom';
import { CheckBoxItem } from 'components/Input/Checkbox/CheckBoxItem';
import moment from 'moment';
import { BtnApprove, BtnDraft, BtnSave, BtnSend } from 'components/Button/ButtonAll';
import _ from "lodash";
//#endregion

const Present403 = () => { //นำเสนอวิชาการ/ตีพิมพ์ 40(3) << (ลักษณะงาน เป็น nMasterDataID = 69 งานวิจัย)
    const { 
        nProjectID,
        isPermission,
        nStatusID,
        isModeSecretary,
        ObjStepFlowProject,
        sPathNameBack,
        sMode,
    } = useContext(ProjectContext);

    const AxiosFn = FnAxios();
    const DialogFn = FnDialog();
    const location = useLocation();
    const navigate = useNavigate();
    const Router = RouterDOM();

    //#region useState
    // const [isRequesterTeam, setisRequesterTeam] = useState(false); //Requester + หัวหน้าโครงการ + ผู้ประสานงาน
    // const [isSecretary, setisSecretary] = useState(false); //เลขา

    const [isEdit, setisEdit] = useState(false);
    const [nPresentStatusID, setnPresentStatusID] = useState(0);
    const [nPresentFormID, setnPresentFormID] = useState(0);

    const [dProjectStart, setdProjectStart] = useState(null);

    const [isBtn_DraftPresent, setisBtn_DraftPresent] = useState(false); //Requester >> บันทึกร่าง
    const [isBtn_SendPresent, setisBtn_SendPresent] = useState(false); //Requester >> รอเลขาตรวจสอบ
    const [isBtn_ConfirmSendPresent, setisBtn_ConfirmSendPresent] = useState(false); //เลขา >> เลขาตรวจสอบแล้ว

    const [lstPresentTypeID, setlstPresentTypeID] = useState([]); //ข้อมูลหัวข้อ
    const [lstInternationalType, setlstInternationalType] = useState([]); //ข้อมูล Fix (ระดับชาติ && ระดับนานาชาติ)

    const [lstProjectPresent403, setlstProjectPresent403] = useState([]); //ข้อมูล
    //#endregion

    const formPresent = useForm({
        // shouldUnregister: false,
        shouldFocusError: true,
        mode: "all",
        defaultValues: {} as any,
    });

    useEffect(() => {
        if (nProjectID !== 0) GetFormInitial();
    }, [nProjectID]);

    useEffect(() => {
        if(ObjStepFlowProject !== null) setisEdit((ObjStepFlowProject?.isPermission_Tab9 && isModeSecretary) ? true : ObjStepFlowProject?.isPermission_Tab8 === true && sMode === "Present"); //Requester + หัวหน้าโครงการ + ผู้ประสานงาน
    }, [ObjStepFlowProject]);

    const GetFormInitial = () => {
        AxiosFn.Get(ApiProject.GetFormProjectPresent403, { nProjectID : nProjectID }, (result) => { 
            setisBtn_DraftPresent(result.isBtn_DraftPresent); //Requester >> บันทึกร่าง
            setisBtn_SendPresent(result.isBtn_SendPresent); //Requester >> รอเลขาตรวจสอบ
            setisBtn_ConfirmSendPresent(result.isBtn_ConfirmSendPresent); //เลขา >> เลขาตรวจสอบแล้ว

            setlstPresentTypeID(result.lstPresentTypeID) //ข้อมูลหัวข้อ
            setlstInternationalType(result.lstInternationalType); //ข้อมูล Fix (ระดับชาติ && ระดับนานาชาติ)
            setlstProjectPresent403(result.lstProjectPresent403); //ข้อมูล

            setdProjectStart(moment(result.nDateProjectStart)); //วันที่เริ่มต้นโครงการ
            setnPresentStatusID(result.nPresentStatusID);
            setnPresentFormID(result.nPresentFormID);
        });
    }

    const handleSubmit = (nModeID: EnumSaveModeProject, nStatusID: EnumProjectPresentStatusID, sStatusName: string) => {
        let lstFileAll = [...lstProjectPresent403].filter(f => f.isPresent === true && (f.lstFilePresent || []).length === 0);
        // let lstFileAll = [...lstProjectPresent403].filter(x => x.isPresent === true && (x.lstFilePresent.some(c => c.isDelete === false)).length === 0);
        if ((lstFileAll || []).length > 0) {
            return DialogFn.Warning("กรุณาอัพโหลดไฟล์แนบเอกสาร");
        }

        let lstProjectPresent = [...lstProjectPresent403].filter(f => f.isPresent === true);
        if ((lstProjectPresent || []).length === 0) {
            return DialogFn.Warning("กรุณาเพิ่มข้อมูลอย่างน้อย 1 หัวข้อ");
        }

        let param = {
            nProjectID: nProjectID,
            sLocation: location.pathname,
            nSaveModeProject: nModeID,
            nStatusID: nStatusID,

            nPresentFormID: nPresentFormID,
            lstProjectPresent403: lstProjectPresent403,
        };
        DialogFn.Submit("คุณต้องการ" + sStatusName + "หรือไม่ ?", () => {
            DialogFn.BlockUI();
            AxiosFn.Post(ApiProject.SaveProjectPresent403, param, (result) => {
                DialogFn.UnBlockUI();
                if (result.nStatusCode === APIStatusCode.Success)
                {
                    DialogFn.Success(sStatusName + "สำเร็จ", () => {       
                        if (nStatusID !== EnumProjectPresentStatusID.nPresentStatusID_0) handleBack();
                    });
                } else {
                    DialogFn.Warning(result.sMessage);                    
                }
            }, (err) => {
                DialogFn.UnBlockUI();
                if (!err.response) {
                    DialogFn.Warning(err.sMessage);
                }
            });
        });
    };

    const handleBack = () => {
        let sNameBack = "/Project";
        let sPathName = Router.GetCurrentRoute();
        if (sPathName === "/projectsrequestingfrom") sNameBack = "/ProjectList";
        navigate(sPathNameBack !== null ? sPathNameBack : sNameBack);
    }

    // const [isInternational, setisInternational] = useState(false);
    // const ObjProjectPresent = useMemo(() => {
      
    // }, [isInternational])

    const GetPresentFrom = (ObjProjectPresent, sNameFrom) => {
        return(
            <PresentFrom
                sMode={"403"}
                sNameFrom={sNameFrom}
                isEdit={isEdit}
                isPresent={(ObjProjectPresent?.isPresent ?? false) && isEdit}
                ObjProjectPresent={ObjProjectPresent}
                dProjectStart={dProjectStart}
            />
        );
    }

    const CallTablePresent = useCallback(() => {
        return(
            <Grid item xs={12} md={12} container spacing={2}>
                {(lstPresentTypeID || []).map((iPresentType) => {
                    return (
                        <Grid item xs={12} md={12} container spacing={1} key={"iPresentType_" + iPresentType.value}>
                            <AccordionPanel
                                header={iPresentType.label}
                                isExpanded={false}
                                color="white"
                                bgColor="rgb(102,151,245)"
                                background="#e79a09"
                                expandIconColor="white"
                                borderColor="1px solid #e79a09"
                                borderRadius="20px !important"
                                boxShadowHead="-4px 2px 12px -10px rgba(0,0,0,0.96)"
                                boxShadowDetail="1px 6px 10px -4px rgb(0 0 0 / 15%)"                            
                            >
                                <Grid id={"myDivPresent403_" + iPresentType.value} item xs={12} md={12} container spacing={1} style={{ padding: '1%', paddingBottom: '1%', }}>
                                    {(lstInternationalType || []).map((iInternationalType) => {
                                        let isInternational = iInternationalType.value !== 1;
                                        let sName = iPresentType.value + "_" + iInternationalType.value;

                                        //รูปแบบนี้มันอัพเดตตัวหลัก
                                        let lstProjectPresent = lstProjectPresent403.filter(f => f.nPresentTypeID === iPresentType.value && f.isInternational === isInternational);
                                        let ObjProjectPresent = (lstProjectPresent || []).length > 0 ? lstProjectPresent[0] : null;

                                        //รูปแบบนี้ไม่อัพเดตตัวหลัก
                                        // let lstProjectPresent = [...lstProjectPresent403].filter(f => f.nPresentTypeID === iPresentType.value && f.isInternational === isInternational);
                                        // let lstProjectPresentAll = _.cloneDeep(lstProjectPresent);
                                        // let ObjProjectPresent = (lstProjectPresentAll || []).length > 0 ? lstProjectPresentAll[0] : null;

                                        return (
                                            <Grid id={"myDivPresent403_International_" + iInternationalType.value} item xs={12} md={12} container spacing={1} style={{ paddingBottom: '1%', }}>
                                                <Grid item xs={12} md={12}>
                                                    <CheckBoxItem
                                                        id={"isInternational_" + sName}
                                                        name={"isInternational_" + sName}
                                                        options={[iInternationalType]}
                                                        required={false}
                                                        disabled={!isEdit}
                                                        defaultValue={ObjProjectPresent?.isPresent ?? false}
                                                        onChange={(e) => {
                                                            // if (ObjProjectPresent !== null && e === true)
                                                            // {
                                                            //     ObjProjectPresent.isPresent = e;
                                                            // }
                                                            // else if (e === false)
                                                            // {
                                                            //     ObjProjectPresent.isPresent = e;
                                                            //     ObjProjectPresent.sEventName = null;
                                                            //     ObjProjectPresent.dPresentStart = null;
                                                            //     ObjProjectPresent.nDatePresentStart = null;
                                                            //     ObjProjectPresent.dPresentEnd = null;
                                                            //     ObjProjectPresent.nDatePresentEnd = null;
                                                            //     ObjProjectPresent.sDetail = null;
                                                            //     ObjProjectPresent.sJournalName = null;
                                                            //     ObjProjectPresent.sArticleTitle = null;
                                                            //     ObjProjectPresent.sPresentBy = null;
                                                            //     ObjProjectPresent.lstFilePresent = []; //ไฟล์ทั้งหมด TbProjectPresentFile
                                       
                                                            //     let sEventName = "sEventName_" + sName;
                                                            //     let dPresentStart = "dPresentStart_" + sName;
                                                            //     let dPresentEnd = "dPresentEnd_" + sName;
                                                            //     let sDetail = "sDetail_" + sName;
                                                            //     let sJournalName = "sJournalName_" + sName;
                                                            //     let sArticleTitle = "sArticleTitle_" + sName;
                                                            //     let sPresentBy = "sPresentBy_" + sName;

                                                            //     formPresent.setValue(sEventName, null);
                                                            //     formPresent.setValue(dPresentStart, null);
                                                            //     formPresent.setValue(dPresentEnd, null);
                                                            //     formPresent.setValue(sDetail, null);
                                                            //     formPresent.setValue(sJournalName, null);
                                                            //     formPresent.setValue(sArticleTitle, null);
                                                            //     formPresent.setValue(sPresentBy, null);

                                                            //     formPresent.unregister(sEventName);
                                                            //     formPresent.clearErrors(sEventName);
                                                            //     formPresent.unregister(dPresentStart);
                                                            //     formPresent.clearErrors(dPresentStart);
                                                            //     formPresent.unregister(dPresentEnd);
                                                            //     formPresent.clearErrors(dPresentEnd);
                                                            //     formPresent.unregister(sDetail);
                                                            //     formPresent.clearErrors(sDetail);     
                                                            //     formPresent.unregister(sJournalName);
                                                            //     formPresent.clearErrors(sJournalName);  
                                                            //     formPresent.unregister(sArticleTitle);
                                                            //     formPresent.clearErrors(sArticleTitle); 
                                                            //     formPresent.unregister(sPresentBy);
                                                            //     formPresent.clearErrors(sPresentBy);     
                                                                
                                                            //     formPresent.reset({
                                                            //         ...formPresent.watch(),
                                                            //     });
                                                            // }
                                                            // setlstProjectPresent403(value => [...value]);

                                                            let lstProjectPresent = [...lstProjectPresent403]
                                                            let indEdit = lstProjectPresent.findIndex(f => f.nPresentTypeID === iPresentType.value && f.isInternational === isInternational);
                                                            lstProjectPresent[indEdit].isPresent = e;
                                                            if (e === false)
                                                            {
                                                                lstProjectPresent[indEdit].sEventName = null;
                                                                lstProjectPresent[indEdit].dPresentStart = null;
                                                                lstProjectPresent[indEdit].nDatePresentStart = null;
                                                                lstProjectPresent[indEdit].dPresentEnd = null;
                                                                lstProjectPresent[indEdit].nDatePresentEnd = null;
                                                                lstProjectPresent[indEdit].sDetail = null;
                                                                lstProjectPresent[indEdit].sJournalName = null;
                                                                lstProjectPresent[indEdit].sArticleTitle = null;
                                                                lstProjectPresent[indEdit].sPresentBy = null;
                                                                lstProjectPresent[indEdit].lstFilePresent = []; //ไฟล์ทั้งหมด TbProjectPresentFile           

                                                                let sEventName = "sEventName_" + sName;
                                                                let dPresentStart = "dPresentStart_" + sName;
                                                                let dPresentEnd = "dPresentEnd_" + sName;
                                                                let sDetail = "sDetail_" + sName;
                                                                let sJournalName = "sJournalName_" + sName;
                                                                let sArticleTitle = "sArticleTitle_" + sName;
                                                                let sPresentBy = "sPresentBy_" + sName;

                                                                formPresent.setValue(sEventName, null);
                                                                formPresent.setValue(dPresentStart, null);
                                                                formPresent.setValue(dPresentEnd, null);
                                                                formPresent.setValue(sDetail, null);
                                                                formPresent.setValue(sJournalName, null);
                                                                formPresent.setValue(sArticleTitle, null);
                                                                formPresent.setValue(sPresentBy, null);

                                                                formPresent.unregister(sEventName);
                                                                formPresent.clearErrors(sEventName);
                                                                formPresent.unregister(dPresentStart);
                                                                formPresent.clearErrors(dPresentStart);
                                                                formPresent.unregister(dPresentEnd);
                                                                formPresent.clearErrors(dPresentEnd);
                                                                formPresent.unregister(sDetail);
                                                                formPresent.clearErrors(sDetail);     
                                                                formPresent.unregister(sJournalName);
                                                                formPresent.clearErrors(sJournalName);  
                                                                formPresent.unregister(sArticleTitle);
                                                                formPresent.clearErrors(sArticleTitle); 
                                                                formPresent.unregister(sPresentBy);
                                                                formPresent.clearErrors(sPresentBy);     
                                                                
                                                                formPresent.reset({
                                                                    ...formPresent.watch(),
                                                                });
                                                            }                                                         
                                                            setlstProjectPresent403([...lstProjectPresent]);

                                                            // setisInternational(isInternational ? false : true);
                                                        }}
                                                    />
                                                </Grid>
                                                <Grid item xs={12} md={12}>
                                                    {GetPresentFrom(ObjProjectPresent, sName)}
                                                </Grid>
                                            </Grid> 
                                        )
                                    })}   
                                </Grid> 
                            </AccordionPanel>
                        </Grid>
                    )
                })}
            </Grid>
        );
    }, [lstPresentTypeID, lstInternationalType, lstProjectPresent403]);

    return (
        <Grid item xs={12} md={12} container spacing={2} style={{ padding: '2%', paddingBottom: '1%', }}>
            <Grid item xs={12} md={12} container spacing={1} justifyContent={'start'}>
                <Typography variant='h6' color={'#225192'}>ข้อมูลส่วนการนำเสนอ/ตีพิมพ์วารสารทางวิชาการ</Typography>
            </Grid>
            <Grid item xs={12} md={12} container spacing={2} style={{ paddingBottom: '1%', }}>
                <FormProvider {...formPresent}>
                    <Grid item xs={12} md={12} container spacing={2} justifyContent={'start'}>
                        <CallTablePresent />
                        <Grid item xs={12} md={12} container spacing={1} justifyContent="center" style={{ paddingBottom: '1%', paddingTop: '1%', }}>
                            {isBtn_DraftPresent &&
                                //Requester >> บันทึกร่าง
                                <Grid item>
                                    <BtnDraft 
                                        id="BtnDraft_Present403"
                                        txt={I18n.SetText("Button.Draft", I18NextNs.labelComponent)}
                                        onClick={formPresent.handleSubmit((e) => handleSubmit(EnumSaveModeProject.Draft, EnumProjectPresentStatusID.nPresentStatusID_0, I18n.SetText("Button.Draft", I18NextNs.labelComponent)),(err) => {
                                            document.getElementById(Object.keys(err)[0])?.focus();
                                            console.log("err", err);
                                        })}
                                    />
                                </Grid>
                            }
                            {isBtn_SendPresent &&
                                //Requester >> รอเลขาตรวจสอบ
                                <Grid item>
                                    <BtnSave 
                                        id="BtnSubmit_Present403"
                                        txt={I18n.SetText("Button.Save", I18NextNs.labelComponent)}
                                        onClick={formPresent.handleSubmit((e) => handleSubmit(EnumSaveModeProject.Submit, EnumProjectPresentStatusID.nPresentStatusID_1, I18n.SetText("Button.Save", I18NextNs.labelComponent)),(err) => {
                                            document.getElementById(Object.keys(err)[0])?.focus();
                                            console.log("err", err);
                                        })}
                                    />
                                </Grid>
                            }
                            {(isBtn_ConfirmSendPresent && isModeSecretary === true && isPermission) &&
                                //เลขา >> เลขาตรวจสอบแล้ว
                                <Grid item>
                                    <BtnApprove
                                        id="BtnConfirm_Present403"
                                        txt={I18n.SetText("Button.Confirm", I18NextNs.labelComponent)}
                                        onClick={formPresent.handleSubmit((e) => handleSubmit(EnumSaveModeProject.Approve, EnumProjectPresentStatusID.nPresentStatusID_2, I18n.SetText("Button.Confirm", I18NextNs.labelComponent)),(err) => {
                                            document.getElementById(Object.keys(err)[0])?.focus();
                                            console.log("err", err);
                                        })}
                                    />
                                </Grid>
                            }
                        </Grid>
                    </Grid>
                </FormProvider>              
            </Grid> 
        </Grid>       
    )
}
export default Present403;